<ng-container *ngIf="errors[name]">
  <p
    *ngFor="let error of errors[name]"
    class="text-danger mt-2 mr-2 d-block text-right mb-0"
    style="font-size: small"
  >
    {{ error }}
  </p>
</ng-container>
